import React from 'react'
import { Route, Router } from 'react-router-dom'
import { SnackbarProvider } from 'notistack'

import AppFrame from './components/organisms/AppFrame'
import PopupWrapper from 'shared-ui/components/popup/PopupWrapper'
import PageWrapper from 'shared-ui/components/pages/PageWrapper'
import { createBrowserHistory } from 'history'
import { ApiProvider } from 'shared-ui/api/ApiContext'
import SnackMessages from 'shared-ui/components/molecules/SnackMessages'
import ErrorHandler from 'shared-ui/components/pages/ErrorHandler'

import ApiConnector from 'shared-ui/api/ApiConnector'
import PortalApi from './api/PortalApi'
import getComponentByName from './componentLoaderByName'
import PortalThemeProvider from 'shared-ui/assets/styles/PortalThemeProvider'
import MsalB2CAuthProvider from './auth/MsalB2CAuthProvider'

import CustomSnackBar from 'shared-ui/components/atoms/CustomSnackBar'

const apiUrl = process.env.VITE_API_URL

const apiConnector = new ApiConnector(apiUrl)
const portalApi = new PortalApi(apiConnector)

const history = createBrowserHistory()

export const HistoryContext = React.createContext(history)

export default function App() {
  return (
    <Router history={history}>
      <HistoryContext.Provider value={history}>
        <Route
          render={({ location, history }) => (
            <PortalThemeProvider>
              <ErrorHandler>
                <>
                  <ApiProvider api={portalApi}>
                    <SnackbarProvider
                      maxSnack={4}
                      dense
                      preventDuplicate
                      Components={{
                        success: CustomSnackBar,
                        error: CustomSnackBar,
                        warning: CustomSnackBar,
                        info: CustomSnackBar,
                      }}
                    >
                      <SnackMessages />
                      <PageWrapper
                        getComponentByName={getComponentByName}
                        AppFrame={AppFrame}
                        PopupWrapper={PopupWrapper}
                        location={location}
                        history={history}
                      />
                    </SnackbarProvider>
                  </ApiProvider>
                </>
              </ErrorHandler>
            </PortalThemeProvider>
          )}
        />
      </HistoryContext.Provider>
    </Router>
  )
}
